(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-kolliflower-menu"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.video-thumbnail').forEach(button => {
    button.addEventListener('click', () => {
      const videoUrl = button.getAttribute('data-video-url');
      const modal = document.getElementById('video-modal');
      const video = document.getElementById('modal-video');
      video.src = videoUrl;
      modal.style.display = 'flex';
    });
  });

  document.getElementById('close-video').addEventListener('click', () => {
    const modal = document.getElementById('video-modal');
    const video = document.getElementById('modal-video');
    video.pause();
    video.src = '';
    modal.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();
})();
